import { useMemo } from "react"
import { useAuth } from "react-oidc-context"
import { ApiClient } from "./client"

export function useApi(): ApiClient {
  const auth = useAuth()
  // In local dev route API calls through the Vite proxy (/__api) to avoid the
  // prod API's CORS rejection of localhost; in prod use the configured base.
  const apiBase = import.meta.env.DEV ? "/__api" : window.__EYESIGHT_CONFIG__.apiBase
  return useMemo(() => new ApiClient({
    apiBase,
    getIdToken: async () => auth.user?.id_token ?? null,
  }), [auth.user?.id_token, apiBase])
}
